import React from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import _ from 'lodash';
import cx from 'classnames';

import messages from '../../MLSummary.messages'
import styles from '../../MLSummary.module.scss'

function MLUmbrellaExclusions({ data, show }) {
    const translator = useTranslator();

    if (_.isEmpty(data)) {
        return null;
    }

    if (show) {
        return (
            <div className="vertical-spacing-40">
                <h2 className="section-header vertical-spacing-20">
                    {translator(messages.Exclusions)}
                </h2>
                <table className={cx('table table-striped', styles.tableStriped)}>
                    <tbody>
                        {data.map((coverage) => {
                            return (
                                <tr>
                                    <td><strong>{coverage.name}</strong></td>
                                    <td>
                                        {coverage.value.map((v) => {
                                            return (
                                                <div>{v}</div>
                                            );
                                        })}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    }
    return ( <></> );
}

MLUmbrellaExclusions.propTypes = {
    data: PropTypes.shape([]),
    show: PropTypes.bool
};
MLUmbrellaExclusions.defaultProps = {
    data: [],
    show: false
};
export default MLUmbrellaExclusions;
